






























































































































































/* tslint:disable */
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Watch, Component } from 'vue-property-decorator';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import {
  ColumnsAdjustRequestData,
  ColumnSortRequestData,
  PageNumberChangeRequestData,
  PageSizeChangeRequestData,
  PaginationConfig,
  SortedColumnInfo,
  TableColumnConfig,
  TableEntry,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import { InfoState, SetHelpContentIdPayload } from '@/core';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import uuifComponent from '@/shared/uuifComponent';
import { ContentToolbarExpandFilterBlock } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import {
  SwExpandableTextfield,
  SwTextfield,
} from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import _ from 'lodash';
import { Mutation } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
const cssPrefix = 'snb-quote-history-component';

@Component({
  components: {
    ...uuifComponent,
    MswAppTitle,
    SwDropMenu,
    SwIcon,
    SwIconButton,
    SwTextfield,
    SwExpandableTextfield,
  },
})
export default class SandboxQuoteHistory extends SwExtendedVue {
  /* tslint:disable */
  cssPrefix = cssPrefix;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  expandVisible: boolean = false;
  filterBlockGrid: ContentToolbarExpandFilterBlock[][] = [];
  quoteID: string = '';
  quoteDate: string = '';
  quoteDescription: string = '';
  quoteExpiresOn: string = '';
  quoteAmount: string = '';
  isExpandSearchFilter: boolean = false;
  searchInputText = '';
  @Watch('searchInputText')
  searchInputTextChanged(val: any) {
    if (val === '') {
      // this.setNotifications(this.notifications);
      // this.makeTableData();
      this.filterApplied = false;
    }
  }

  quoteFilter: any;
  // quoteHistoryData: any;
  totalRecords: number = 0;
  rowData: any;
  columnDefs: any[];
  spinner: boolean = false;
  enableSearch: boolean = false;
  searchKey = '';
  appliedFilter = [];
  filtersConfig = [];
  filterHoverValues: boolean = false;
  columnWidth: number;
  snbuser: string = '';
  quoteHistoryColumnsConfig: any;

  // Martian updates
  menuOpened: boolean = false;
  selectedMenuItem: string = '';
  searchValue: any = '';
  search: any = '';
  menuItems: DropMenuItem[] = [];
  textExpanded: boolean = false;
  apiResponse: any = [];
  isParent = true;
  deleteReason: string = '';
  showDeleteReasonModal: boolean = false;
  // TABLE STUFF STARTS
  filterColumnKey: string = '';
  filterColumnValue: string = '';
  filterApplied: boolean = false;
  tableData: TableEntry[] = [];
  filteredTableData: TableEntry[] = [];
  tableColConfig: TableColumnConfig[] = [];
  sortedColumns: SortedColumnInfo[] = [];
  isLoadingPartialDataset: boolean = false;
  partialDatasetPaginationConfig: PaginationConfig = {
    pageNumber: 1,
    pageSize: 50,
    datasetOffset: 0,
    datasetTotal: 0,
  };
  selectedUserId: any = '';
  userDetailModal: boolean = false;
  deleteSubscriptionName: any = '';
  deleteSubscriptionID: any = '';
  subscriptionEndDate: any = '';
  cancelDate: any = '';
  deleteRecord: {
    subscriptionEndDate: any;
    cancelDate: any;
    comments: string;
  } = {
    subscriptionEndDate: '',
    cancelDate: '',
    comments: '',
  };

  get isPageLoading(): boolean {
    return this.$store.getters.loading;
  }

  adjustedColumns: ColumnsAdjustRequestData = {};

  get quoteHistoryData() {
    return this.$store.getters['SnbQuotesStoreModule/getQuoteHistoryData'];
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  onRequestSorting(data: ColumnSortRequestData) {
    const template = {
      secaasSubscriptionId: '',
      invoiceId: '',
      pageSize: this.partialDatasetPaginationConfig.pageSize,
      pageNo: this.partialDatasetPaginationConfig.pageNumber,
      sortColumn: data.colKey.toUpperCase(),
      sortOrder: '',
    };
    const index = this.sortedColumns.findIndex((col) => col.colKey === data.colKey);
    if (index < 0) {
      if (data.cancel) {
        return;
      }
      this.applySort({ ...template, sortOrder: 'desc' }).then((response: any) => {
        this.sortedColumns.splice(0);
        this.sortedColumns.push({
          colKey: data.colKey,
          ascending: !!data.ascending,
        });
        this.$store.commit('stopLoading');
        // this.setApiResponse(response);
      });
    } else {
      if (data.cancel) {
        this.sortedColumns.splice(index, 1);
        return;
      }
      // this is sort using spi
      this.applySort({ ...template, sortOrder: 'asc' }).then((response: any) => {
        this.sortedColumns[index].ascending = !!data.ascending;
        this.$store.commit('stopLoading');
        // this.setApiResponse(response);
      });
    }
  }

  async applySort(template: any) {
    this.$store.commit('startLoading');
    const data = await this.$store.dispatch(
      'SnbQuotesStoreModule/getAllQuoteHistoryData',
      template,
    );
    return data;
  }

  makeTableData() {
    const tableData = this.$store.getters['SnbQuotesStoreModule/getQuoteHistoryData'].map(
      (el: any, index: any) => {
        return {
          ...el,
          _key: index,
        };
      },
    );
    this.tableData = tableData;
  }

  makeTableConfig() {
    const makeElipsis = (item: string, size = 20) => {
      if (item.length > size) {
        return `${item.slice(0, size)}...`;
      }
      return item;
    };
    const tableConfig: TableColumnConfig[] = [
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'quoteId',
        dataKey: 'quoteId',
        title: this.$t('quote.quoteID')
        .toString(),
        sorter: true,
        width: 120,
        tooltip: {
          content: this.$t('quote.quoteID')
          .toString(),
          compact: true,
        },
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.quoteId;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                <a style='font-weight: bold' onClick={() => this.openQuoteDetails(data.entry)}>
                  {data.entry.quoteId}
                </a>
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.quoteId && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.quoteID = data.entry.quoteId;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'quoteDate',
        dataKey: 'quoteDate',
        title: this.$t('quote.quoteDate')
        .toString(),
        sorter: true,
        width: 150,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.quoteDate;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                {data.entry.quoteDate}
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.quoteDate && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.quoteDate = data.entry.quoteDate;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'desc',
        dataKey: 'desc',
        title: this.$t('common.description')
        .toString(),
        sorter: true,
        // width: 300,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.desc;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                {makeElipsis(data.entry.desc, 50)}
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.desc && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.quoteDescription = data.entry.desc;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'dtexpiryOn',
        dataKey: 'dtexpiryOn',
        title: this.$t('products.expirydate')
        .toString(),
        sorter: true,
        width: 150,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.dtexpiryOn;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                {data.entry.dtexpiryOn}
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.dtexpiryOn && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.quoteExpiresOn = data.entry.dtexpiryOn;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'amount',
        dataKey: 'amount',
        title: this.$t('quoteHistory.amt')
        .toString(),
        sorter: true,
        width: 150,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.amount;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                {data.entry.amount}
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.amount && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.quoteAmount = data.entry.amount;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
    ];

    this.tableColConfig = tableConfig;
  }

  get partialDatasetData(): TableEntry[] {
    if (this.isLoadingPartialDataset) {
      return [];
    }
    return this.tableData.slice(
      this.partialDatasetPaginationConfig.datasetOffset,
      this.partialDatasetPaginationConfig.datasetOffset! +
        this.partialDatasetPaginationConfig.pageSize,
    );
  }

  async openQuoteDetails(data: any) {
    this.selectedUserId = await data.quoteId;
    this.$router.push({
      path: `quoteDetails?selectedQuoteId=${this.selectedUserId}`,
    });
  }

  exportExcel() {
    const excelList: any = [];
    let column:any[] = [];
    column.push('QUOTE ID');
    column.push('QUOTE DATE');
    column.push('DESCRIPTION');
    column.push('EXPIRY DATE');
    column.push('AMOUNT');
    excelList.push(column);
    column = [];
    for (const headers of this.tableData) {
      column.push(headers.quoteId);
      column.push(headers.quoteDate);
      column.push(headers.desc);
      column.push(headers.dtexpiryOn);
      column.push(headers.amount);
      excelList.push(column);
      column = [];
    }
    const csvContent = ''.concat(excelList.map((e:any) => e.join(','))
    .join('\n'));
    const blob = new Blob([(csvContent)]);
    const link:any = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'QuoteHistory.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
  }

  reloadData() {
    this.quoteID = '';
    this.quoteDate = '';
    this.quoteDescription = '';
    this.quoteExpiresOn = '';
    this.quoteAmount = '';
    this.filterApplied = false;
    this.expandVisible = false;
    this.isExpandSearchFilter = false;
    this.getQuoteHistory();
    // this.fetchAllData();
  }

  toLoad: number = 50;

  onChangePartialDatasetPageNumber(data: PageNumberChangeRequestData) {
    this.partialDatasetPaginationConfig.pageNumber = data.pageNumber;
    this.partialDatasetPaginationConfig.datasetOffset =
      Math.max(this.partialDatasetPaginationConfig.pageNumber - 1, 0) *
      this.partialDatasetPaginationConfig.pageSize;
    this.isLoadingPartialDataset = true;
    this.isLoadingPartialDataset = false;
  }

  onChangePartialDatasetPageSize(data: PageSizeChangeRequestData) {
    this.partialDatasetPaginationConfig.pageSize = data.pageSize;
    /** we also need to make sure the page number is within the reasonable range */
    this.partialDatasetPaginationConfig.pageNumber = Math.min(
      this.partialDatasetPaginationConfig.pageNumber,
      Math.ceil(
        this.partialDatasetPaginationConfig.datasetTotal! /
          this.partialDatasetPaginationConfig.pageSize,
      ),
    );
    this.partialDatasetPaginationConfig.datasetOffset =
      Math.max(this.partialDatasetPaginationConfig.pageNumber - 1, 0) *
      this.partialDatasetPaginationConfig.pageSize;
    this.isLoadingPartialDataset = false;
  }

  // showConfirmDialog(message: string) {
  //   const buttonsTransferConfirm: ConfirmButton[] = [
  //     { key: 'cancel', name: 'Cancel' },
  //     { key: 'save', name: 'Confirm', isDefault: true },
  //   ];
  //   const optionsTransferConfirm: ConfirmOptions = {
  //     message,
  //     status: 'high',
  //     title: 'Warning',
  //     buttons: buttonsTransferConfirm,
  //   };
  //   return confirmService.confirm(optionsTransferConfirm);
  // }

  handleClear(): void {
    this.partialDatasetPaginationConfig.pageNumber = 1;
    this.search = '';
    this.getQuoteHistory();
  }

  // async filterSearch() {
  //   this.partialDatasetPaginationConfig.pageNumber = 1;
  //   const conditions = {
  //     filterName: this.decideFilterName(this.selectedMenuItem),
  //     filterValue: this.searchValue.trim(),
  //     filterCondition: '',
  //   };
  //   this.isLoadingPartialDataset = true;
  //   let items: any = await getDataFromIdb('secaasSubscriptions');
  //   const searchResults: any = items.filter((el: any) => {
  //     // @ts-ignore
  //     return el[this.decideFilterName(this.selectedMenuItem)]
  //     .toLowerCase()
  //     .includes(this.searchValue.toLowerCase()
  //     .trim());
  //   });
  //   items = [];
  //   const updatedData = searchResults.map((el: any, index: any) => {
  //     return {
  //       ...el,
  //       _key: index,
  //     };
  //   });
  //   if (searchResults.length > 0) {
  //     this.setTotalDataSize(searchResults.length);
  //     this.tableData = updatedData.slice(0, searchResults > 50 ? 50 : searchResults.length);
  //     this.isLoadingPartialDataset = false;
  //   }

  //   if (searchResults.length === 0) {
  //     this.getQuoteHistory('', conditions);
  //   }
  // }

  onClickMenuButton(): void {
    this.menuOpened = !this.menuOpened;
  }

  onSelectItem(itemId: string): void {
    this.selectedMenuItem = itemId;
    this.onClickMenuButton();
    setTimeout(() => {
      (document
        .getElementsByClassName('sw-textfield__wrapper__input')
        .namedItem(itemId) as HTMLElement).focus();
    }, 500);
  }

  decideFilterName(item: any) {
    switch (item.toLowerCase()) {
      case 'subscription name':
        return 'subscriptionName';
      case 'customer name':
        return 'customerName';
      case 'subscription id':
        return 'subscriptionId';
      case 'status':
        return 'status';
      case 'account id':
        return 'accountId';
      case 'version':
        return 'version';
      case 'contract effective date':
        return 'contractEffectiveDate';
      case 'current term':
        return 'currentTerm';
      case 'renewal term':
        return 'renewalTerm';
      case 'po number':
        return 'poNumber';
      case 'oracle order number':
        return 'oracleOrderNumber';
      case 'cmrr':
        return 'cmrr';
      case 'effective date':
        return 'contractEffectiveDate';
      case 'account number':
        return 'accountNumber';
    }
  }

  setTotalDataSize(size: any) {
    this.partialDatasetPaginationConfig = {
      pageNumber: 1,
      datasetTotal: size,
      pageSize: 50,
    };
  }

  // async handleCommonSearch() {
  //   this.partialDatasetPaginationConfig.pageNumber = 1;
  //   const conditions = {
  //     filterName: this.decideFilterName('subscription name'),
  //     filterValue: this.search.trim(),
  //     filterCondition: 'like',
  //   };
  //   this.isLoadingPartialDataset = true;
  //   let items: any = await getDataFromIdb('secaasSubscriptions');
  //   const searchResults: any = items.filter((el: any) => {
  //     return el.subscriptionName
  //     .toLowerCase()
  //     .includes(this.search.toLowerCase()
  //     .trim())
  //   });
  //   items = [];
  //   const updatedData = searchResults.map((el: any, index: any) => {
  //     return {
  //       ...el,
  //       _key: index,
  //     }
  //   });
  //   if (searchResults.length > 0) {
  //     this.setTotalDataSize(searchResults.length);
  //     this.tableData = updatedData.slice(0, searchResults > 50 ? 50 : searchResults.length);
  //     this.isLoadingPartialDataset = false;
  //   }

  //   if (searchResults.length === 0) {
  //     this.getQuoteHistory('', conditions);
  //   }
  // }

  makeMenuItems(): void {
    const menuItems: any = [];
    menuItems.push({
      id: 'Oracle order number',
      content: this.$t('quote.oracleOrdNum')
      .toString(),
    });
    this.tableColConfig.forEach((el: any) => {
      if (el.key !== 'action') {
        menuItems.push({
          id: el.title,
          content: el.title,
        });
      }
    });
    this.menuItems = menuItems;
  }

  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    // this.$store.commit('displayMessage', message);
    this.$store.commit('enqueueMessage', message);
  }

  // fetchAllData() {
  //   getCompleteSubscriptionList().then((response: any) => {
  //     saveDataToIdb('secaasSubscriptions', response.content.secaasSubscriptionList);
  //   });
  // }
  handleSearchFilter() {
    if (this.searchInputText.trim() === '') {
      return;
    }
    // let filteredNotifications = [];
    this.filteredTableData = _.filter(this.tableData, (o: any) => {
      let flag = false;
      if (
        o.quoteId.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.quoteDate.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.desc.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.dtexpiryOn.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.amount.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1
      ) {
        flag = true;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    // this.$store.commit(
    //   'NotificationCenterStoreModule/setSelectedNotifications',
    //   filteredNotifications,
    // );
    // this.makeTableData();
    this.filterApplied = true;
  }

  mutateFilterState(name: any, event: any) {
    switch (name) {
      case 'quoteID':
        this.quoteID = event;
        break;
      case 'date':
        this.quoteDate = event;
        break;
      case 'description':
        this.quoteDescription = event;
        break;
      case 'expiresOn':
        this.quoteExpiresOn = event;
        break;
      case 'amount':
        this.quoteAmount = event;
        break;
      case 'searchInputText':
        this.searchInputText = event;
        break;
    }
    if (
      !this.quoteID &&
      !this.quoteDate &&
      !this.quoteDescription &&
      !this.quoteExpiresOn &&
      !this.quoteAmount &&
      !this.searchInputText
    ) {
      // this.setNotifications(this.notifications);
      // this.makeTableData();
      this.filterApplied = false;
    }
  }

  applyFilters() {
    // let filteredNotifications = [];
    this.filteredTableData = _.filter(this.tableData, (o: any) => {
      let flag = true;
      if (
        this.quoteID !== '' &&
        o.quoteId.toLowerCase().indexOf(this.quoteID.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.quoteDate !== '' &&
        o.quoteDate.toLowerCase().indexOf(this.quoteDate.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.quoteDescription !== '' &&
        o.desc.toLowerCase().indexOf(this.quoteDescription.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.quoteExpiresOn !== '' &&
        o.dtexpiryOn.toLowerCase().indexOf(this.quoteExpiresOn.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.quoteAmount !== '' &&
        o.amount.toLowerCase().indexOf(this.quoteAmount.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    // this.$store.commit(
    //   'NotificationCenterStoreModule/setSelectedNotifications',
    //   filteredNotifications,
    // );
    // this.makeTableData();
    this.filterApplied = true;
  }

  private viewQuoteIDRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'quoteID',
              value: this.quoteID,
              placeholder: this.$t('quote.quoteID')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('quoteID', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewDateRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'date',
              value: this.quoteDate,
              placeholder: this.$t('quote.quoteDate')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('date', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewDescriptionRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'description',
              value: this.quoteDescription,
              placeholder: this.$t('common.description')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('description', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewExpiresOnRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'expiresOn',
              value: this.quoteExpiresOn,
              placeholder:this.$t('products.expirydate')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('expiresOn', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewAmountRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'amount',
              value: this.quoteAmount,
              placeholder: this.$t('quoteHistory.amt')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('amount', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }

  createFilterGrid() {
    const tableHeader = document.querySelector('.msw-table-toolbar') as HTMLElement;
    let totalWidth = 0;
    if (tableHeader) {
      totalWidth = tableHeader.getBoundingClientRect().width;
    }
    this.filterBlockGrid = [
      [
        { title: this.$t('quote.quoteID')
          .toString(), content: this.viewQuoteIDRender, width: totalWidth / 5 || 200 },
        { title: this.$t('quote.quoteDate')
          .toString(), content: this.viewDateRender, width: totalWidth / 5 || 200 },
        {
          title: this.$t('common.description')
          .toString(),
          content: this.viewDescriptionRender,
          width: totalWidth / 5 || 200,
        },
        {
          title: this.$t('products.expirydate')
          .toString(),
          content: this.viewExpiresOnRender,
          width: totalWidth / 5 || 200,
        },
        { title: this.$t('quoteHistory.amt')
          .toString(), content: this.viewAmountRender, width: totalWidth / 5 || 200 },
      ],
    ];
  }

  mounted() {
    this.setHelpId('quotehistory');
    this.createFilterGrid();
    if (this.$route.query.subscriptionName) {
      this.makeTableConfig();
      this.search = this.$route.query.subscriptionName;
      // this.handleCommonSearch();
    }
    // this.route.queryParams.subscribe(params => {
    //   if (params.snbuser && this.userInfoService.isSandbox) {
    //     this.snbuser = params['snbuser'];
    //   }
    // })
    else if (this.$route.query.subscriptionDeleted === 'YES') {
      this.reloadData();
    } else {
      this.getQuoteHistory();
      // this.fetchAllData();
    }
    this.makeMenuItems();
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  destroyed() {
    this.setHelpId('default');
  }

  setApiResponse(resp: any) {
    this.$store.dispatch(
      'SnbQuotesStoreModule/setQuoteHistoryData',
      resp.content.quoteDetails,
    );
    this.$store.dispatch(
      'SnbQuotesStoreModule/setQuoteHistoryDataTotalRecords',
      resp.content.quoteDetails.length,
    );
    this.makeTableConfig();
    this.makeMenuItems();
    this.makeTableData();
    this.partialDatasetPaginationConfig.datasetTotal = this.$store.getters[
      'SnbQuotesStoreModule/getQuoteHistoryDataTotalRecords'
    ];
  }

  getQuoteHistory(quoteHistory = '', filterConditions = {}) {
    this.isLoadingPartialDataset = true;
    const template = {
      quoteHistory: quoteHistory,
      invoiceId: '',
      pageSize: this.partialDatasetPaginationConfig.pageSize,
      pageNo: this.partialDatasetPaginationConfig.pageNumber,
      ...filterConditions,
    };
    this.$store
      .dispatch('SnbQuotesStoreModule/getQuoteHistory')
      .then((resp: any) => {
        this.quoteFilter = resp.content.quoteDuration;
        if (resp.msgCode == 'MSWAPP:SUCCESS') {
          this.setApiResponse(resp);
        } else {
          this.setApiResponse(resp);
          this.rowData = [];
        }
        this.$store.commit('stopLoading');
      })
      .catch((error: any) => {
        // snb-revisit :: remove next line
        console.warn('SNBQuoteHistory :: ', error);
      });
  }
}
